import PropTypes from "prop-types"
import React from "react"
import Card from "../cards/Card"

const CardsGrid = ({ items }) => {
  return (
    <div className="px-6 lg:px-10">
      <div className="grid grid-flow-row md:grid-cols-2 lg:grid-cols-3 gap-8">
        {items.map(item => (
          <Card {...item} key={item.id} />
        ))}
      </div>
    </div>
  )
}

CardsGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default CardsGrid
